<div class="ManipulativeContainer">
  <div class="ManipFractionStripsTable">
    <div class="cell_bar">
      <div class="ManipFractionStripsContainer">
        <div class="target-line" *ngIf="fractionParams.targetLine > 0"
             [ngStyle]="{ width: fractionParams.targetLine + '%' }"
        ></div>
        <div class="row-fluid">
          <div class="thumbnail-wrapper"
               cdkDropList
               cdkDropListOrientation="horizontal"
               (cdkDropListDropped)="drop($event)">
            <div class="thumbnail hthumbnail ManipFractionStripStrip"
                 [ngStyle]="{ 'width' : fraction.width + '%', 'background' : fraction.colour }"
                 *ngFor="let fraction of strips; index as ind"
                 cdkDrag>
              <div class="label_numerator">1</div>
              <br/>
              <div class="label_denominator">{{fraction.fraction}}</div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div *ngIf="fractionParams.showFraction" class="cell_fraction text-nowrap">
      =&nbsp;{{sum.Numerator}}<span *ngIf="sum.Denominator !== 1">/{{sum.Denominator}}</span>
    </div>
  </div>

 
  <div *ngIf="!(hideStudentManipControlBar | async)"
    class="ManipAlgebraTilesBar StudentManipControlBar StudentManipControlBarBottomOnMobile">
    <div class="kh-bottom-bar-container w-100 d-flex justify-content-center align-content-center kh-horizontal-scroll-bar ">
      <div class="kh-bottom-bar-content-container w-100 d-flex justify-content-between align-items-center  flex-shrink-0">
        <div class="w-100 d-flex align-items-center   flex-shrink-0 flex-grow-1">
          <div class=" d-flex align-items-center kh-justify-content-align-controls  flex-shrink-0 flex-grow-1">
            <button #add type="button" (click)="addFractionStrip()"
              class="btn-md kh-blue-button white kh-lg-title-text text-uppercase kh-no-wrap kh-secondory-controls">
              <fa-icon [icon]="['fas', 'plus']" class="mr-2"></fa-icon>{{ 'MANIP_FRACTION_STRIPS.STRIP' | translate }}
            </button>
            <button #reset type="button"
              class="btn-md kh-blue-button white kh-lg-title-text text-uppercase kh-no-wrap kh-secondory-controls mr-2"
              (click)="resetClick()"> <fa-icon [icon]="['fas','redo']" class="mr-2"></fa-icon>{{ 'MANIP_FRACTION_STRIPS.RESET' | translate }}</button>
          </div>
          <div class="justify-content-end kh-submit-width  flex-shrink-0 ">
            <button
              class="btn-md kh-green-button kh-green-accessible white kh-lg-title-text text-uppercase kh-no-wrap  manipulative-submit-button  "
              type="button" *ngIf="isManipChanged && !questionClosed" (click)="submit()"
              [class.animated]="isManipChanged"><img
                src="https://staticcontent.knowledgehook.com/content/icons/question/submitarrow-onprimary.svg">
            </button>
          </div>
        </div>
  
      </div>
    </div>
  </div>
</div>